
import { FILE_TRANSFER_DOWNLOAD_ADDRESS } from '../app/constants'

export function createHTML(messageDisplayAreaRef) {
  return `
  <!DOCTYPE html>
  <html>
  <head lang="en">
    <meta charset="UTF-8">
    <title>test</title>
    <link rel="stylesheet" href="https://vm.providesupport.com/printChatTranscriptStyles.css" type="text/css">
    <style>
      .file-message-wraper .file-message:not(.file-error) .file-name { padding-left: 0 }
      .file-cannot-be-downloaded {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: not-allowed;
        a {
          cursor: not-allowed;
          pointer-events: none;
        }
        svg {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }
      }
    </style>
  </head>

  <body>
    ${messageDisplayAreaRef.current.wrapperRef.innerHTML}
  </body>
  </html>
  `
}

function trimStringByStrings(string, start, finish) {
  const startIndex = ~string.indexOf(start) ? (string.indexOf(start) + start.length) : 0;
  const finishIndex = ~string.indexOf(finish) ? string.indexOf(finish) : string.length;
  return string.slice(startIndex, finishIndex)
}

export function createTXT(transcript, texts, accountName) {
  transcript = { ...transcript }
  /* set default values */
  transcript.visitor = transcript.visitor || {}
  transcript.visitor.name = transcript.visitor.name || ''
  transcript.visitor = transcript.agents || ''

  const { postChatSurvey, startChatForm, startDate, endDate, visitor } = transcript
  return `${texts['transcript-txt-header']}

${texts['company']}: ${accountName}
${texts['started']}: ${new Date(startDate).toLocaleString()}
${endDate
    ? `${texts['finished']}: ${new Date(endDate).toLocaleString()}`
    : ''
}

${texts['visitor']}: ${visitor.name}
${
  transcript.assignedOperator ? `${texts['assigned-operator']}: ${transcript.assignedOperator.nickname}
` : ''}${
  transcript.acceptedOperator ? `${texts['accepted-operator']}: ${transcript.acceptedOperator.nickname}
` : ''}${
  transcript.invitedOperatorNicknames ? `${texts['invited-operator']}: ${transcript.invitedOperatorNicknames}
` : ''}
${transcript.messages.reduce((sum, message) => {
    const { authorName, text, translatedText, created, lastEditedTime } = message;
    const isFile = ~text.indexOf(FILE_TRANSFER_DOWNLOAD_ADDRESS);
    let res = ''
    if (isFile) {
      res = `${trimStringByStrings(text, '">', '</a>')} ${FILE_TRANSFER_DOWNLOAD_ADDRESS}${trimStringByStrings(text, '_ADDRESS}', '" ')}`
    } else {
      const time = created ? `${new Date(created).toLocaleString()}: ` : '';
      const isEdited = lastEditedTime && lastEditedTime !== '0';
      const edited = isEdited ? ` (${texts['edited'] || 'edited'} ${new Date(+lastEditedTime).toLocaleString()})` : '';
      res = `${time}${authorName}: ${text}${translatedText ? ` | ${translatedText}` : ''}${edited}`;
    }
    return `${sum}
${res}`
  }, '')}

${startChatForm
    ? `${texts['visitor-details']}
---------------${
  Object.keys(startChatForm).reduce((sum, key) => `${sum}
${key}: ${startChatForm[key]}`,
  '')}`
    : ''
}

${postChatSurvey
    ? `${texts['post-chat-survey']}
---------------
${Object.entries(postChatSurvey)
    .filter(([_, value]) => value)
    .map(([key, value]) => {
      let text = texts[key.toLowerCase().replace(/\s+/g, '-')] || key
      return `${text}: ${value}`
    })
    .join('\n')
}
`
    : ''
}

`
}
